import { SxProps, Theme } from "@mui/material";

// MUI's default typography variants don't scale with viewport width (no
// responsiveFontSizes() wrapper is used in this app's theme), so headings
// stay desktop-sized on phones unless given an explicit responsive
// fontSize. Shared here since every dashboard card repeats the same two
// text roles: a card title and a hero number/value.

export const cardTitleSx: SxProps<Theme> = {
  fontSize: { xs: 14.5, sm: 15.5 },
  fontWeight: 600,
  color: "#0f172a",
};

export const heroValueSx: SxProps<Theme> = {
  fontSize: { xs: "1.5rem", sm: "1.9rem" },
  fontWeight: 800,
  letterSpacing: "-0.02em",
  color: "#0f172a",
  fontVariantNumeric: "tabular-nums",
};

// Same card shell as the admin dashboard: rounded, hairline border, soft shadow.
export const dashboardCardSx: SxProps<Theme> = {
  height: "100%",
  border: "1px solid #e5e7eb",
  borderRadius: 3,
  boxShadow: "0 1px 2px rgba(15, 23, 42, 0.04)",
  "& .MuiCardContent-root": { p: { xs: 2, md: 2.5 } },
  "& .MuiCardContent-root:last-child": { pb: { xs: 2, md: 2.5 } },
};
